import React from "react";

const Footer = () => {
  return (
    <footer
      className="footer bg-light text-dark"
      style={{ marginTop: "5%", padding: "5%" }}
    >
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <h3>Contact Information</h3>
            <a href={`tel:+201110115999`} className="Blondie">
              {/* {row.value.ptPhone} */}
              <p>Phone: +201110115999</p>
            </a>
            <a href={`tel:+201200040895`} className="Blondie">
              {/* {row.value.ptPhone} */}
              <p>Phone: +201200040895</p>
            </a>
            <p>Email: elhall.clinic@gmail.com</p>
            <p>
              16 Dawletian street - from Nile Cournish street - Aghakhan - KFC
              tower - level 3
            </p>
          </div>
          <div className="col-md-3">
            <h3>Social Media</h3>
            <ul className="list-unstyled">
              <li>
                <a
                  href="https://www.facebook.com/elhallclinics"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Facebook
                </a>
              </li>
              {/* <li>
                <a
                  href="https://example.com/twitter"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Twitter
                </a>
              </li> */}
              {/* <li>
                <a
                  href="https://example.com/instagram"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Instagram
                </a>
              </li> */}
            </ul>
          </div>
          <div className="col-md-3">
            <h3>Important Links</h3>
            <ul className="list-unstyled">
              <li>
                <a href="/about">About Us</a>
              </li>
              <li>
                <a href="/services">Our Services</a>
              </li>
              <li>
                <a href="/contact">Contact Us</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
